import { Link } from "react-router-dom";
import SEO from "../components/SEO";

export default function NotFound() {
  return (
    <>
      {/* Soft-404 guard: catch-all route must be noindex. */}
      <SEO noindex title="Page not found" description="The page you requested could not be found on Ohio Accident Aid." />
      <section className="min-h-[60vh] flex flex-col items-center justify-center px-6 py-20 text-center" data-testid="not-found-page">
        <div className="text-7xl md:text-9xl font-display font-black text-forest mb-4">404</div>
        <h1 className="text-2xl md:text-4xl font-display font-bold text-forest mb-3">Page not found</h1>
        <p className="text-charcoal-soft max-w-md mb-8">
          The page you're looking for doesn't exist or has been moved. Let's get you back on track.
        </p>
        <Link to="/" className="btn-primary" data-testid="not-found-home-link">Go to homepage</Link>
      </section>
    </>
  );
}
